<script setup>
import { computed, ref } from 'vue'

const props = defineProps({ check: { type: Object, required: true } })
const selected = ref(null)
const response = ref('')
const revealed = ref(false)
const kind = computed(() => props.check.type || 'multiple_choice')
const normalize = value => String(value ?? '').normalize('NFC').trim().toLocaleLowerCase('vi').replace(/\s+/g, '').replaceAll(',', '.').replace(/[−–]/g, '-').replace(/^\+(?=\d)/, '')
const correct = computed(() => kind.value === 'multiple_choice'
  ? selected.value === props.check.correct_index
  : normalize(response.value) === normalize(props.check.correct_answer))

function choose(index) {
  selected.value = index
  revealed.value = true
}
</script>

<template>
  <div class="lesson-check">
    <span>TỰ KIỂM TRA</span><h3>{{ check.prompt }}</h3>
    <div v-if="kind === 'multiple_choice'" class="lesson-check-options">
      <button v-for="(option, optionIndex) in check.options" :key="optionIndex" type="button" :aria-pressed="selected === optionIndex" :class="{ selected: selected === optionIndex, correct: selected === optionIndex && correct, wrong: selected === optionIndex && !correct }" @click="choose(optionIndex)">{{ option }}</button>
    </div>
    <div v-else-if="kind === 'fill_blank'" class="lesson-check-answer"><input v-model="response" class="form-control" :aria-label="check.prompt" placeholder="Viết câu trả lời của em" @input="revealed = false"><button type="button" class="btn btn-light" :disabled="!response.trim()" @click="revealed = true">Kiểm tra</button></div>
    <div v-else class="lesson-check-answer"><textarea v-model="response" class="form-control" :aria-label="check.prompt" rows="3" placeholder="Em thử giải thích bằng lời của mình" /><button type="button" class="btn btn-light" :disabled="!response.trim()" @click="revealed = true">Xem gợi ý đối chiếu</button></div>
    <p v-if="revealed" class="lesson-check-feedback" aria-live="polite"><strong>{{ kind === 'reflection' ? 'Gợi ý:' : correct ? 'Đúng rồi!' : 'Chưa đúng, em xem lại nhé.' }}</strong> {{ check.explanation }}</p>
  </div>
</template>
